import React from 'react';
import PropTypes from 'prop-types';
import { Box, Heading, IconButton } from '@components/common';
import PropertySelect from '@containers/properties/PropertySelect';
import useDetectSize from '@hooks/useDetectSize';

function CalendarViewHeader(props) {
  const {
    title,
    onPrev,
    onNext,
    property,
    onSelectProperty,
    ...restProps
  } = props;

  const isMobile = useDetectSize();
  const renderMobileLayout = () => {
    return (
      <Box
        height={48}
        flexDirection="row"
        display="flex"
        justifyContent="space-between"
        {...restProps}
      >
        <IconButton
          onClick={() => {
            if (!onPrev) {
              return;
            }
            onPrev();
          }}
          name="backward"
          width={16}
          height={16}
        />
        <Heading px={2} py={0} my={0}>
          {title}
        </Heading>
        <IconButton
          onClick={() => {
            if (!onNext) {
              return;
            }
            onNext();
          }}
          name="forward"
          width={16}
          height={16}
        />
      </Box>
    );
  };
  const renderDesktopLayout = () => {
    return (
      <Box
        height={48}
        flexDirection="row"
        display="flex"
        alignSelf="stretch"
        justifyContent="flex-start"
        px={2}
        {...restProps}
      >
        <Heading py={0} my={0}>
          {title}
        </Heading>
        <Box flex={1} px={4}>
          <PropertySelect
            value={property}
            onChange={onSelectProperty}
            allowAll={true}
          />
        </Box>
        <Box flexDirection="row" display="flex" justifyContent="center">
          <IconButton
            onClick={() => {
              if (!onPrev) {
                return;
              }
              onPrev();
            }}
            name="backward"
            mr={4}
            width={16}
            height={16}
          />
          <IconButton
            onClick={() => {
              if (!onNext) {
                return;
              }
              onNext();
            }}
            name="forward"
            ml={4}
            width={16}
            height={16}
          />
        </Box>
      </Box>
    );
  };

  return isMobile ? renderMobileLayout() : renderDesktopLayout();
}

CalendarViewHeader.propTypes = {
  title: PropTypes.string,
  onPrev: PropTypes.func,
  onNext: PropTypes.func,
  property: PropTypes.object
};

export default CalendarViewHeader;
